"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _color = _interopRequireDefault(require("color"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

var _colorStringToTheme = _interopRequireDefault(require("../../utils/colorStringToTheme"));

var _excluded = ["label", "id", "error", "helperText", "wrapperProps", "noLabel", "iconName", "trailingIconName", "iconStyle", "onChange", "onClick", "height", "bg", "fontSize", "border", "borderColor", "padding", "noHighlight", "maxLength", "focusedBackgroundColor", "borderRadius", "labelHeight", "className", "iconButton", "iconButtonProps", "hoverText", "hoverTextProps", "disableIconButton"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HoverBox = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "TextField__HoverBox",
  componentId: "sc-xodz4-0"
})(["position:absolute;border:1px solid #686868;bottom:", ";width:fit-content;right:", ";z-index:9999;background-color:", ";padding:", ";color:", ";font-size:", ";"], function (_ref) {
  var bottom = _ref.bottom;
  return bottom || "-25px";
}, function (_ref2) {
  var right = _ref2.right;
  return right || "0px";
}, function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor || "#f4f4f4";
}, function (_ref4) {
  var padding = _ref4.padding;
  return padding || "5px 20px";
}, function (_ref5) {
  var color = _ref5.color;
  return color || "#757575";
}, function (_ref6) {
  var fontSize = _ref6.fontSize;
  return fontSize || "12px";
});

var FormField = _styledComponents["default"].input.withConfig({
  displayName: "TextField__FormField",
  componentId: "sc-xodz4-1"
})(["", " ", " ", " &:hover{background-color:", ";}&:focus{background-color:", ";border-bottom-width:", "px;};transition:0.15s;margin-bottom:1px;& + label{color:", ";transform:translateY(-70%) translateX(-15%) scale(0.75);}&:disabled{opacity:0.6;cursor:not-allowed;& + label{opacity:0.6;}}&:invalid{box-shadow:none;}padding:", ";border-radius:", ";caret-color:", ";font-family:", ";font-size:", "px;font-weight:400;color:", ";line-height:1.75;letter-spacing:0.009375em;border:", ";border-bottom-color:", ";border-bottom-width:", "px;border-bottom-style:", ";background-color:", ";outline:0;margin-bottom:1px;& + label{color:", ";font-family:", ";left:", ";right:auto;top:20px;pointer-events:none;position:absolute;line-height:1.15rem;transition:0.15s;transform:translateY(-70%) translateX(-15%) scale(0.75);}&[value=\"\"]{& + label{transform:none;}&:focus{& + label{color:", ";transform:translateY(-70%) translateX(-15%) scale(0.75);}}}"], _styledSystem.width, _styledSystem.space, _styledSystem.height, function (_ref7) {
  var theme = _ref7.theme,
      bg = _ref7.bg,
      focusedBackgroundColor = _ref7.focusedBackgroundColor;

  if (focusedBackgroundColor) {
    return focusedBackgroundColor;
  }

  return (0, _color["default"])((0, _colorStringToTheme["default"])(theme, bg)).darken(0.04).rgb().toString();
}, function (_ref8) {
  var theme = _ref8.theme,
      bg = _ref8.bg,
      focusedBackgroundColor = _ref8.focusedBackgroundColor;

  if (focusedBackgroundColor) {
    return focusedBackgroundColor;
  }

  return (0, _color["default"])((0, _colorStringToTheme["default"])(theme, bg)).darken(0.04).rgb().toString();
}, function (_ref9) {
  var noHighlight = _ref9.noHighlight,
      border = _ref9.border;

  if (border) {
    return null;
  }

  if (noHighlight) {
    return "none";
  }

  return 2;
}, function (_ref10) {
  var theme = _ref10.theme,
      error = _ref10.error,
      noHighlight = _ref10.noHighlight;

  if (noHighlight) {
    return theme.colors.dark[2];
  }

  return error ? theme.colors.error[0] : theme.colors.primary[0];
}, function (_ref11) {
  var label = _ref11.label,
      padding = _ref11.padding,
      iconName = _ref11.iconName;

  if (padding) {
    return padding;
  }

  return label ? "20px 16px 6px " + (iconName ? 40 : 16) + "px" : "14px 20px 14px " + (iconName ? 40 : 14) + "px";
}, function (_ref12) {
  var borderRadius = _ref12.borderRadius;

  if (typeof borderRadius === "number") {
    return borderRadius + "px";
  }

  return borderRadius || "4px 4px 0 0";
}, function (_ref13) {
  var theme = _ref13.theme,
      error = _ref13.error;
  return error ? theme.colors.error[0] : theme.colors.primary[0];
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fonts.sansSerif;
}, function (_ref15) {
  var fontSize = _ref15.fontSize;
  return fontSize;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.dark[1];
}, function (_ref17) {
  var border = _ref17.border;
  return border || "none";
}, function (_ref18) {
  var theme = _ref18.theme,
      error = _ref18.error,
      noHighlight = _ref18.noHighlight,
      border = _ref18.border,
      borderColor = _ref18.borderColor;

  if (border) {
    return null;
  }

  if (noHighlight) {
    return "none";
  }

  if (borderColor) {
    return (0, _colorStringToTheme["default"])(theme, borderColor);
  }

  return error ? theme.colors.error[0] : theme.colors.primary[1];
}, function (_ref19) {
  var noHighlight = _ref19.noHighlight,
      border = _ref19.border;

  if (border) {
    return null;
  }

  if (noHighlight) {
    return "none";
  }

  return 1;
}, function (_ref20) {
  var noHighlight = _ref20.noHighlight,
      border = _ref20.border;

  if (border) {
    return null;
  }

  if (noHighlight) {
    return "none";
  }

  return "solid";
}, function (_ref21) {
  var theme = _ref21.theme,
      bg = _ref21.bg;
  return (0, _colorStringToTheme["default"])(theme, bg);
}, function (_ref22) {
  var theme = _ref22.theme,
      error = _ref22.error;
  return error ? theme.colors.error[0] : theme.colors.primary[0];
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.fonts.sansSerif;
}, function (_ref24) {
  var iconName = _ref24.iconName;
  return iconName ? "40px" : "16px";
}, function (_ref25) {
  var theme = _ref25.theme,
      error = _ref25.error,
      noHighlight = _ref25.noHighlight;

  if (noHighlight) {
    return theme.colors.dark[2];
  }

  return error ? theme.colors.error[0] : theme.colors.primary[0];
});

var IconFlex = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "TextField__IconFlex",
  componentId: "sc-xodz4-2"
})(["position:absolute;align-content:center;align-items:center;margin-left:10px;"]);
var IconFlex2 = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "TextField__IconFlex2",
  componentId: "sc-xodz4-3"
})(["position:absolute;align-content:center;align-items:center;right:10px;"]);
var AbsoluteIconButton = (0, _styledComponents["default"])(_IconButton["default"]).withConfig({
  displayName: "TextField__AbsoluteIconButton",
  componentId: "sc-xodz4-4"
})(["position:absolute;align-content:flex-end;align-items:center;size:auto;"]);

var TextField = function TextField(_ref26) {
  var _ref26$label = _ref26.label,
      label = _ref26$label === void 0 ? "" : _ref26$label,
      _ref26$id = _ref26.id,
      id = _ref26$id === void 0 ? "" : _ref26$id,
      _ref26$error = _ref26.error,
      error = _ref26$error === void 0 ? "" : _ref26$error,
      _ref26$helperText = _ref26.helperText,
      helperText = _ref26$helperText === void 0 ? "" : _ref26$helperText,
      _ref26$wrapperProps = _ref26.wrapperProps,
      wrapperProps = _ref26$wrapperProps === void 0 ? {} : _ref26$wrapperProps,
      _ref26$noLabel = _ref26.noLabel,
      noLabel = _ref26$noLabel === void 0 ? false : _ref26$noLabel,
      _ref26$iconName = _ref26.iconName,
      iconName = _ref26$iconName === void 0 ? null : _ref26$iconName,
      trailingIconName = _ref26.trailingIconName,
      _ref26$iconStyle = _ref26.iconStyle,
      iconStyle = _ref26$iconStyle === void 0 ? {} : _ref26$iconStyle,
      _ref26$onChange = _ref26.onChange,
      onChange = _ref26$onChange === void 0 ? function () {
    return null;
  } : _ref26$onChange,
      _ref26$onClick = _ref26.onClick,
      onClick = _ref26$onClick === void 0 ? function () {
    return null;
  } : _ref26$onClick,
      _ref26$height = _ref26.height,
      height = _ref26$height === void 0 ? 56 : _ref26$height,
      _ref26$bg = _ref26.bg,
      bg = _ref26$bg === void 0 ? "dark.4" : _ref26$bg,
      _ref26$fontSize = _ref26.fontSize,
      fontSize = _ref26$fontSize === void 0 ? 14 : _ref26$fontSize,
      _ref26$border = _ref26.border,
      border = _ref26$border === void 0 ? null : _ref26$border,
      _ref26$borderColor = _ref26.borderColor,
      borderColor = _ref26$borderColor === void 0 ? "primary.0" : _ref26$borderColor,
      _ref26$padding = _ref26.padding,
      padding = _ref26$padding === void 0 ? null : _ref26$padding,
      _ref26$noHighlight = _ref26.noHighlight,
      noHighlight = _ref26$noHighlight === void 0 ? null : _ref26$noHighlight,
      _ref26$maxLength = _ref26.maxLength,
      maxLength = _ref26$maxLength === void 0 ? 0 : _ref26$maxLength,
      _ref26$focusedBackgro = _ref26.focusedBackgroundColor,
      focusedBackgroundColor = _ref26$focusedBackgro === void 0 ? null : _ref26$focusedBackgro,
      _ref26$borderRadius = _ref26.borderRadius,
      borderRadius = _ref26$borderRadius === void 0 ? 0 : _ref26$borderRadius,
      _ref26$labelHeight = _ref26.labelHeight,
      labelHeight = _ref26$labelHeight === void 0 ? 19 : _ref26$labelHeight,
      className = _ref26.className,
      iconButton = _ref26.iconButton,
      iconButtonProps = _ref26.iconButtonProps,
      _ref26$hoverText = _ref26.hoverText,
      hoverText = _ref26$hoverText === void 0 ? false : _ref26$hoverText,
      hoverTextProps = _ref26.hoverTextProps,
      disableIconButton = _ref26.disableIconButton,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref26, _excluded);

  var _useState = (0, _react.useState)(0),
      length = _useState[0],
      setLength = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      text = _useState2[0],
      setText = _useState2[1];

  var handleInput = function handleInput(e) {
    setLength(e.target.value.length);
    onChange(e);
  };

  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
    width: "100%",
    height: "auto",
    position: "relative",
    flexDirection: "column",
    className: className
  }, wrapperProps), iconName && /*#__PURE__*/_react["default"].createElement(IconFlex, {
    height: height,
    width: "auto",
    className: "leading-icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    name: iconName
  }, iconStyle))), trailingIconName && /*#__PURE__*/_react["default"].createElement(IconFlex2, {
    height: height,
    width: "auto",
    className: "trailing-icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    name: trailingIconName
  }, iconStyle))), /*#__PURE__*/_react["default"].createElement(FormField, (0, _extends2["default"])({
    id: id,
    height: height,
    borderRadius: borderRadius,
    noHighlight: noHighlight,
    error: error,
    bg: bg,
    borderColor: borderColor,
    iconName: iconName,
    label: label,
    fontSize: fontSize,
    border: border,
    padding: padding,
    focusedBackgroundColor: focusedBackgroundColor,
    width: "100%",
    maxLength: maxLength > 0 ? maxLength : undefined,
    onChange: handleInput,
    className: "text-field"
  }, props)), label && /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id
  }, label), !noLabel && /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    width: "100%",
    height: labelHeight,
    justifyContent: "space-between",
    alignItems: "center",
    className: "helper-text-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: error ? "error.0" : "dark.2",
    fontSize: 2,
    ml: typeof borderRadius === "number" ? borderRadius : 0,
    className: "helper-text"
  }, error || helperText), maxLength > 0 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: error ? "error.0" : "dark.2",
    fontSize: 2,
    ml: typeof borderRadius === "number" ? borderRadius : 0,
    width: "auto",
    className: "helper-text-max-length"
  }, length + "/" + maxLength)), iconButton && /*#__PURE__*/_react["default"].createElement(AbsoluteIconButton, (0, _extends2["default"])({
    icon: iconButton,
    onClick: onClick,
    onMouseEnter: hoverText,
    setText: setText,
    disableIconButton: disableIconButton
  }, iconButtonProps)), text && /*#__PURE__*/_react["default"].createElement(HoverBox, hoverTextProps, text));
};

var _default = TextField;
exports["default"] = _default;